var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"storefront-btn-blue inline-block ml-3 h-8 mb-2",attrs:{"type":"button","aria-label":"Edit this section"},on:{"click":_vm.onEdit}},[_c('span',{staticClass:"inline-block"},[_vm._v("Edit")])])}
var staticRenderFns = []

export { render, staticRenderFns }